<template>
<div id="room-media">
    <div id="dropzone" class="d-none" ref="dragzone">
        <div class="text-dropzone">{{ $t('room_type.media.message_drop') }}</div>
    </div>
    <v-card flat :class="{'pa-3':$vuetify.breakpoint.mdAndUp, 'pa-1':$vuetify.breakpoint.smAndDown}" height="100%">
        <div class="justify-space-between fill-height align-center d-flex pa-1">
            <div v-if="!$vuetify.breakpoint.smAndDown">
                {{ $t('room_type.media.message_drag_files') }}
            </div>
            <v-btn :block="$vuetify.breakpoint.smAndDown" color="primary">
                <input type="file" ref="fileInput" accept="image/png, image/jpeg" multiple @change="onFileChanged" class="input-file">
                <span style="cursor: pointer;">{{ $t('room_type.media.button.upload_photo') }}</span>
            </v-btn>
        </div>
        <div v-if="all_images.length < 5" class="pa-1 important">
            {{ $t('room_type.media.message_more_images') }}
        </div>
        <draggable v-model="all_images" @start="drag_started_outside=false" @change="onChange()">
            <transition-group class="drag-flex-img">
                <div v-for="(element,index) in all_images" :key="element.id" class="mx-1 image-div-room">
                    <img :src="element.url" class="image-room">
                    <div class="icons-div">
                        <v-icon class="mx-1 pa-1" size="28" color="red" @click="openDeleteDialog(index,element.id)">delete</v-icon>
                    </div>
                </div>
            </transition-group>
        </draggable>

    </v-card>
    <!--delete dialog-->
    <v-dialog v-model="delete_dialog" max-width="320">
        <v-card>
            <v-card-text class="px-3 pt-5">
                {{ $t('room_type.media.message_delete_confimation') }}
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn dark color="red" :loading="delete_loading" @click="destroy()">
                    {{ $t('button.delete') }}
                </v-btn>
                <v-btn color="primary" text @click="delete_dialog=false">
                    {{ $t('button.cancel') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!--./delete dialog -->

    <v-snackbar v-model="error_image" color="error" bottom left>
        Formatul nu este acceptat. Va rugam incarcati jpg, png!
        <v-btn dark text @click="error_image = false">
            <v-icon>close</v-icon>
        </v-btn>
    </v-snackbar>
</div>
</template>

<script>
import {
    mapActions
} from 'vuex';
import draggable from 'vuedraggable';
import logger from '../../../../logger.js';

const message = [
  "vue.draggable",
  "draggable",
  "component",
  "for",
  "vue.js 2.0",
  "based",
  "on",
  "Sortablejs"
];

export default {
    props: {
        is_mounted: {
            type: Boolean,
            default: false
        },
        item: Object,
        new_images: Array
    },
    name: `room-media`,
    components: {
        draggable,
    },
    data() {
        return {
            error_image: false,
            files: [],
            delete_loading: false,
            delete_dialog: false,
            drag_started_outside: true,
            all_images: this.item.images,
            images: this.new_images,
            unique_ids: [],
            default_image: null,
            tab_hotel: null,
            description: null,
        };
    },

    watch: {
        images: {
            handler: function () {
                this.$emit('addPhotos', this.images);
            }
        },
        'item.images': function (old_hotel, new_hotel) {
            this.all_images = this.$clone(this.item.images);
            this.unique_ids = [];
            this.images = this.$clone(this.new_images);
        },

    },

    mounted() {
        const self = this;
        let dropzone = document.getElementById("dropzone");

        window.addEventListener("dragenter", function (e) {
            if(self.drag_started_outside) {
                dropzone.classList.remove("d-none");
            }
        });

        window.addEventListener("dragover", function (e) {
            e.preventDefault();
        });

        window.addEventListener("drop", function (e) {
            try {
                e.preventDefault();
                dropzone.classList.add("d-none");
                let image_types = ['image/png', 'image/jpg', 'image/jpeg'];
                let drag_files = e.target.files || e.dataTransfer.files;
                if(!drag_files.length) {
                    return;
                }
                Array.prototype.forEach.call(drag_files, file => {
                    if(image_types.includes(file.type)) {
                        self.createImage(file);
                    } else {
                        self.error_image = true;
                    }
                });
                drag_files = [];

            } catch (error) {
                let trace = error.stack ? error.stack : 'components/items/RoomType/items/Media.vue';
                logger.error(`[Window.Error] ` + error.message, trace)
            }
        })

        this.$refs['dragzone'].addEventListener("dragleave", function (e) {
            e.preventDefault();
            dropzone.classList.add("d-none");
        });
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        onFileChanged(event) {
            try {
                const files = event.target.files || event.dataTransfer.files;
                if(!files.length) {
                    return;
                }
                Array.prototype.forEach.call(files, file => {
                    this.createImage(file);
                });
            } catch (error) {
                let trace = error.stack ? error.stack : 'components/items/RoomType/items/Media.vue';
                logger.error(`[Window.Error] ` + error.message, trace)
            }
        },
        generateUniqueId() {
            let nr_id = Math.floor((Math.random() * 10000) + 1);
            if(this.unique_ids.includes(nr_id)) {
                this.generateUniqueId();
            } else {
                this.unique_ids.push(nr_id)
                return nr_id
            }
        },

        createImage(file) {
            let id = this.generateUniqueId();
            try {
                const fileReader = new FileReader();
                fileReader.onload = event => {
                    this.images.push({
                        id: 'abc' + id,
                        caption: "",
                        default: false,
                        tag: "",
                        url: event.target.result
                    });

                    this.all_images.push({
                        id: 'abc' + id,
                        caption: "",
                        default: false,
                        tag: "",
                        url: event.target.result
                    });
                };
                fileReader.readAsDataURL(file);
            } catch (error) {
                let trace = error.stack ? error.stack : 'components/items/RoomType/items/Media.vue';
                logger.error(`[Window.Error] ` + error.message, trace)
            }
        },

        openDeleteDialog(index, id) {
            let value = id.toString();
            if(value.includes("abc")) {
                // photo is a new one added
                this.status_photo = 'new';
                this.id_photo = id;
            } else {
                // photo is an old one and we need to call api
                this.id_photo = id;
                this.status_photo = 'old';
            }
            this.index_photo = index;
            this.delete_dialog = true;
        },

        deleteOldPhoto(file_id, index) {
            this.delete_loading = true;
            let params = {
                params: {
                    hotel_id: this.item.hotel_id
                }
            };
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/room-types/";

            // call delete endpoint
            this.$axios.delete(endpoint + this.$route.params.id + "/delete-image/" + file_id, params)
                .then(response => {
                    this.success(this.$t('room_type.media.message_deleted_photo'));
                    this.all_images.splice(index, 1);
                    this.status_photo = null;
                    this.index_photo = null;
                    this.id_photo = null;
                    this.delete_loading = false;
                    this.delete_dialog = false;
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.error(error);
                })
                .finally(() => {});

        },

        destroy() {
            if(this.status_photo == 'old') {
                this.deleteOldPhoto(this.id_photo, this.index_photo);
                return
            }
            if(this.status_photo == 'new') {
                // remove from Front
                this.all_images.splice(this.index_photo, 1);
                // remove from data for update hotel
                let value_index = this.images.findIndex(photo => photo.id === this.id_photo);
                this.images.splice(value_index, 1);
                this.status_photo = null;
                this.index_photo = null;
                this.id_photo = null;
                this.delete_dialog = false;
                this.success(this.$t('room_type.media.message_deleted_photo'));
                return
            }
        },
        onChange() {
            this.drag_started_outside = true;
            this.$emit('updateDefaultPhoto', this.all_images[0].id);
        },
    },


};
</script>

<style lang="stylus">
.input-file
    opacity: 0
    /* invisible but it's there! */
    top: 0
    width: 100%
    height: 100%
    position: absolute
    cursor: pointer !important

.drag-flex-img
    display: flex
    flex-wrap: wrap

.sortable-ghost
    opacity: 0.2
    background: white

#dropzone
    position: fixed
    /* Sit on top of the page content */
    display: block
    /* Hidden by default */
    width: 100%
    /* Full width (cover the whole page) */
    height: 100%
    /* Full height (cover the whole page) */
    top: 0
    left: 0
    right: 0
    bottom: 0
    background-color: rgba(0, 0, 0, 0.5)
    /* Black background with opacity */
    z-index: 5
    /* Specify a stack order in case you're using a different order for other elements */
    cursor: pointer
    /* Add a pointer on hover */

.text-dropzone
    height: 100%
    width: 100%
    display: flex
    color: white
    font-size: 40px
    align-items: center
    justify-content: center

.icons-div
    display: none
    position: absolute
    top: 5px
    right: 5px
    background-color: rgba(0, 0, 0, 0.4)
    border-radius: 50%
    
img
    &.image-room
        position: relative
        height: 200px
        width: auto
        max-width: 400px
        transition: 0.4s ease
        @media screen and (max-width: 960px)
            height: 150px
        
.image-div-room
    transition: 0.4s ease
    position: relative
    min-width: 100px
    min-height: 100px
    &:hover
        .icons-div
            display: block
        img
            &.image-room
                filter: grayscale(70%)
</style>
